export default "__VITE_ASSET__DAFk9vMY__"